import React, { useState, useEffect, useMemo } from "react";
import Box from "@mui/material/Box";
import Tabs, { tabsClasses } from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { DataGrid } from "@mui/x-data-grid";
import AddServiceForm from "../forms/addServiceForm/AddServiceForm";
import "./ServiceSelectList.css";
import Button from "@mui/material/Button";
import VisibilityIcon from "@mui/icons-material/Visibility";
import EditIcon from "@mui/icons-material/Edit";
import Popup from "reactjs-popup";
import ServiceImportForm from "../forms/serviceImportForm/serviceImportForm";
import { baseUrl } from "../../../../network/constants/constants";
import { Spinner } from "react-bootstrap";
import { getConfig } from "../../../../network/auth";
import axios from "../../../../network/api";
import AppConstants from "../../../AppConstants";
import { Snackbar, Alert } from "@mui/material";

export const ServiceList = ({
  onPageChange,
  serviceList,
  setServiceList,
  categoryList,
  fetchServices,
}) => {
  const [value, setValue] = useState(
    Number(sessionStorage.getItem("selectedTabIndex")) || 0
  );
  const [ImportOpen, setImportOpen] = useState(false);
  const [addOpen, setAddOpen] = useState(false);
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const [loading, setLoading] = useState(false);
  const [importService, setImportService] = useState([]);
  const [serviceToDelete, setServiceToDelete] = useState(null);
  const [isEdit, setIsEdit] = useState(false);
  const [selectedService, setSelectedService] = useState(null);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const config = useMemo(() => {
    return getConfig();
  }, []);

  let bID = localStorage.getItem(AppConstants.business_id);

  const [selectedServiceList, setSelectedServiceList] = useState([]);
  const [categoryIdImport, setCategoryImport] = useState("");


  useEffect(() => {
    if (categoryList.length > 0) {
      const selectedCategory = categoryList[value];
      if (selectedCategory?.id) {
        setServiceList([]);
        fetchServices(selectedCategory?.id);
        setCategoryImport(selectedCategory?.id);
      } else {
        fetchServices(null);
      }
    }
  }, [value, categoryList, fetchServices, setServiceList]);

  const fetchServicImport = () => {
    setLoading(true);
    axios
      .get(baseUrl + `businessadmin/categories-with-services/${bID}/`, config)
      .then((response) => {
        setLoading(false);
        setImportService(response.data);
      })
      .catch((error) => {
        console.error("Import Error:", error);
        setLoading(false);
      });
  };


  useEffect(() => {
    fetchServicImport();
  }, []);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    sessionStorage.setItem("selectedTabIndex", newValue);
  };
  // service import handle functions
  const handleImportForm = () => {
    setImportOpen(true);
  };

  const handleImportCloseForm = () => {
    setImportOpen(false);
  };

  // service add edit handle functions

  const handleAddForm = () => {
    setAddOpen(true);
  };

  const handleEditClick = (service = null) => {
    setIsEdit(true);
    setSelectedService(service);
    setAddOpen(true);
  };

  const handleAddCloseForm = () => {
    setIsEdit(false);
    setAddOpen(false);
  };

  const handleServiceClick = (params) => {
    if (params && params.row) {
      const service_Id = params.row.id;
      onPageChange("sub_service", service_Id, serviceList);
    }
  };

  const handleSubmit = (newService) => {
    setLoading(true);
    const formData = new FormData();

    formData.append("business", bID);
    formData.append("category", newService.category);
    formData.append("service", newService.service);
    formData.append("description", newService.description);
    formData.append("open_time", newService.open_time);
    formData.append("close_time", newService.close_time);
    formData.append("mobile_number", newService.mobile_number);
    formData.append("terms_and_condition", newService.terms_and_condition);

    if (newService.thumb) {
      formData.append("thumb", newService.thumb);
    }

    formData.append("features", JSON.stringify(newService.features));
    formData.append("price_chart", JSON.stringify(newService.price_chart));
    if (isEdit) {
      editData(formData);
    } else {
      submitData(formData);
    }
  };

  const submitData = (formData) => {
    axios
      .post(`${baseUrl}businessadmin/services/create/`, formData, {
        headers: {
          ...config.headers,
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        setLoading(false);
        if (categoryList.length > 0) {
          fetchServices(categoryList[value]?.id);
        }
        setServiceList([...serviceList, response.data]);
        setSnackbar({
          open: true,
          message: response.data.message,
          severity: "success",
        });
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error adding data:", error);
      });
  };

  const editData = (formData) => {
    const id = selectedService?.row?.id;
    axios
      .put(`${baseUrl}businessadmin/service-update/${id}/`, formData, {
        headers: {
          ...config.headers,
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        setLoading(false);
        if (categoryList.length > 0) {
          fetchServices(categoryList[value]?.id);
        }
        setServiceList([...serviceList, response.data]);
        setSnackbar({
          open: true,
          message: response.data.message,
          severity: "success",
        });
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error adding data:", error);
      });
  };

  const handleDeleteClick = (service) => {
    setServiceToDelete(service.id);
    setShowDeletePopup(true);
  };

  const confirmDelete = () => {
    if (serviceToDelete) {
      deleteService(serviceToDelete);
      setServiceToDelete(null);
      setShowDeletePopup(false);
    }
  };

  const deleteService = (serviceId) => {
    setLoading(true);

    axios
      .delete(`${baseUrl}app/service/delete/${serviceId}/`, config)
      .then((response) => {
        if (categoryList.length > 0) {
          fetchServices(categoryList[value]?.id);
        }
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error deleting service:", error);
        setLoading(false);
      });
  };

  const handleServiceImportSubmit = () => {
    
    setLoading(true);
    const postData = {
      category_id: categoryIdImport,
      service_id: selectedServiceList
    };
  

    axios
      .post(`${baseUrl}businessadmin/template-import/${bID}/`,  postData, config)
      .then((response) => {
        setLoading(false);
        if (categoryList.length > 0) {
          fetchServices(categoryList[value]?.id);
        }
        setServiceList([...serviceList, response.data]);
        setSnackbar({
          open: true,
          message: "Services imported successfully!",
          severity: "success",
        });

      })
      .catch((error) => {
        console.error("Error: ", error);
        setLoading(false);
      });
  };

  return (
    <div className="main-div">
      <button className="btn-import" onClick={handleImportForm}>
        Import Service
      </button>
      <button className="btn-add" onClick={handleAddForm}>
        + Add Service
      </button>
      {loading ? (
        <div className="loader-container">
          <Spinner className="spinner-loader" />
        </div>
      ) : (
        <Box
          sx={{
            flexGrow: 1,
            maxWidth: { xs: 650, sm: 1000, lg: 1350 },
            bgcolor: "background.paper",
          }}
        >
          <div className="select-category">Select Category</div>
          <Tabs
            value={value}
            onChange={handleChange}
            variant="scrollable"
            scrollButtons
            aria-label="visible arrows tabs example"
            sx={{
              [`& .${tabsClasses.scrollButtons}`]: {
                "&.Mui-disabled": { opacity: 0.3 },
              },
              "& .MuiTabs-indicator": {
                backgroundColor: "#ff4d4d",
              },
            }}
          >
            {categoryList.map((category, index) => (
              <Tab
                key={index}
                label={
                  <span style={{ display: "flex", alignItems: "center" }}>
                    <img
                      src={`${category.icon}`}
                      alt={category.category_name}
                      style={{ width: 24, height: 24, marginRight: 8 }}
                    />
                    <span>{category.category_name}</span>
                  </span>
                }
                sx={{
                  textTransform: "none",
                  color: value === index ? "#ff4d4d" : "black",
                  "&.Mui-selected": {
                    color: "#ff4d4d",
                    fontSize: "16px",
                    fontWeight: "500",
                  },
                }}
              />
            ))}
          </Tabs>

          <DataGrid
            getRowId={() => crypto.randomUUID()}
            rows={serviceList}
            columns={[
              { field: "id", headerName: "ID", width: 90 },
              { field: "service", headerName: "Service Name", width: 270 },
              {
                field: "actions",
                headerName: "Actions",
                width: 250,
                renderCell: (params) => (
                  <div className="action-btn">
                    <Button
                      variant="outlined"
                      color="success"
                      onClick={() => handleServiceClick(params)}
                    >
                      <VisibilityIcon />
                    </Button>
                    <Button
                      variant="outlined"
                      color="primary"
                      onClick={() => handleEditClick(params)}
                    >
                      <EditIcon />
                    </Button>
                  </div>
                ),
              },
            ]}
            pageSizeOptions={[25, 50, 100]}
            initialState={{
              pagination: {
                paginationModel: {
                  pageSize: 25,
                },
              },
            }}
            disableSelectionOnClick
          />

          <ServiceImportForm
            open={ImportOpen}
            onClose={handleImportCloseForm}
            importService={importService}
            fetchServices={fetchServices}
            selectedServiceList={selectedServiceList}
            setSelectedServiceList={setSelectedServiceList}
            onSubmit={handleServiceImportSubmit}
          />
          <AddServiceForm
            open={addOpen}
            onClose={handleAddCloseForm}
            categoryList={categoryList}
            onSubmit={handleSubmit}
            service={isEdit ? selectedService?.row : null}
          />

          <Popup
            className="popup-container"
            contentStyle={{
              borderRadius: "20px",
              backgroundColor: "white",
            }}
            open={showDeletePopup}
            onClose={() => setShowDeletePopup(false)}
            modal
            nested
          >
            {(close) => (
              <div className="delete-img-div">
                <h3 className="delete-img-heading">Are you sure?</h3>
                <p className="delete-img-p">Do you really want to delete?</p>
                <div className="delete-btn-div">
                  <button onClick={confirmDelete}>Delete</button>
                  <button onClick={close}>Cancel</button>
                </div>
              </div>
            )}
          </Popup>
          <Snackbar
            open={snackbar.open}
            autoHideDuration={6000}
            onClose={() => setSnackbar({ ...snackbar, open: false })}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
          >
            <Alert
              onClose={() => setSnackbar({ ...snackbar, open: false })}
              severity={snackbar.severity}
              sx={{ width: "100%" }}
            >
              {snackbar.message}
            </Alert>
          </Snackbar>
        </Box>
      )}
    </div>
  );
};
